import { observer } from 'mobx-react';
import { FC } from 'react';
import { useForm, withForm } from 'react-bootstrap-formutil';
import W8ben from 'components/forms/TaxForm/W8ben';
import { usePowerNavigate } from 'components/PowerNavigate';
import security from 'stores/security';
import values from 'stores/values';
import { CustomerInfoType } from 'types/customer';
import Container from '../components/Container';

const W8: FC = () => {
    const navigate = usePowerNavigate();
    const { $params } = useForm<CustomerInfoType>();

    return (
        <Container
            onSubmit={() => navigate('../agreements')}
            footerButtonsProps={{
                hidePrev: false,
                nextBtnProps: {
                    content: __('继续')
                }
            }}>
            <h3 className="open-title mt-0">W-8BEN FORM</h3>
            <W8ben customerInfo={$params} disabled />
        </Container>
    );
};

export default withForm(observer(W8), {
    $defaultValues: () => {
        values.setShowProgressBar(false);

        return security.customerInfo;
    }
});
